@import '~less/global-variables';

/**
 * Big "Discover Tribes" grid
 */
.tribes-grid {
  overflow: visible;
  touch-action: pan-y;

  // Circle cards are mostly links and buttons. The global tap optimisation
  // gives those elements `touch-action: manipulation`, which can leave iOS
  // Safari slow or inconsistent about handing a drag back to page scrolling.
  // Keep taps working while making vertical gestures unambiguous.
  .tribe-link,
  .tribe-actions,
  .tribe-join {
    touch-action: pan-y;
  }

  .tribe {
    background-color: @brand-primary;
    background-size: cover;
    height: 250px;
    width: 100%;
    margin: 0;
    padding: 0;
    color: #fff;
    // Animate tile transition animations:
    // transition: all 0.2s ease-out;
  }
  .tribe-link {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    transition: background 0.1s ease-in-out;
    &:hover,
    &:focus {
      background: rgba(255, 255, 255, 0.15);
    }
  }
  .tribe-content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 10px;
    &.is-image {
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.65) 100%
      );
    }
  }
  // Badge for new tribes
  .tribe-new {
    position: absolute;
    padding: 10px;
    font-size: @font-size-large;
    top: 0;
    left: 0;
  }
  .tribe-label {
    font-size: 25px;
    line-height: 30px;
  }
  .tribe-actions {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 5px 10px 10px 5px;
    text-align: right;
    .btn {
      &:hover {
        background: #fff;
      }
    }
  }
  .tribe-join.btn.btn-active {
    opacity: 0.8;
    color: @gray;
    &:hover {
      opacity: 1;
    }
  }
}
